import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';

import { DataService } from '../../providers/data.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  providers: [ConfirmationService]
})
export class ProductsComponent implements OnInit {

   @ViewChild('producttable') producttable:any;

  // @Input() mode: string = 'new';

  now: string = new Date().toISOString();
  show_popup = false;
  loading: boolean;
  preview_hidden = false;
  show_deleted = false;
  last_fetch: Date;
  headers: any;
  // TODO: should be part of settings
  // TODO: make complex objects like swagger ...
  primary_lang: string;
  available_groups = [];
  //detail_attributes = ['id', 'ext_id', 'name', 'description', 'orig_price', 'retail_price', 'base_price', 'status'];
  editable_attributes = [];
  base_editable_attributes = [
    'id',
    this.dataService.SKU_id,
    'certificate_needed!', // bool
    'name_',
    'title_',
    'description_',
    'tag_',
    'note_',
    'filter_',
    'keywords_',
    'max_points_allowed#',
    'order#',
    'unit_count#',
    'max_units#',
    'stock#',
    'retail_price$',
    'orig_price$',
    'base_price$',
    // 'price_from_unit_count&', // added conditionally later !
  ];
  attr_types = {
    '_': 'trans',
    '#': 'number',
    '$': 'price',
    '&': 'bulk',
    '!': 'boolean'

  };
  special_types = [
    {id:'smp', name:"simple discount"},
    {id:'prc', name:"discount in %"},
    {id:'n+m', name:"buy N items get M for FREE"},
    {id:'rst', name:"RESET special offer"},

  ];
  base_headers: any[];
  products: any[];
  assets: any[];
  filter_choices_by_lang = {};
  changed_products = {}; // indexed by prod_id
  selected_products: any[];
  expandedRows = {};
  new_from: number;
  // mode = 'edit'; // or 'select'
  // mode = 'select'; // or 'edit'
  display_special_dialog = false;
  special_definition = {
    type: 'smp',
    perc_discount: null,
    orig_price: null,
    new_price: null,
    base_count: null,
    free_count: null,
    free_prod_id: null,
    progressive_discount: false,
    base_count_1: null,
    free_count_1: null,
    group: null,
    start_date: null,
    end_date: null
  };

  constructor(private dataService: DataService, private route: ActivatedRoute, private confirmService: ConfirmationService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if( !!this.dataService.known_languages){
        this.primary_lang = this.dataService.known_languages[0].toUpperCase();
      };
      // if(!!params['mode']) this.mode = params.mode;
      this.get_products();
    });
  }

  _attr_type_and_name(attr: string){
    const last_char = attr.slice(-1);
    const atype = this.attr_types[last_char]

    let aname = attr;
    if(atype == 'trans'){
      aname = attr + this.primary_lang;
    } else if(!!atype){
      aname = attr.slice(0,-1);
    }
    return [atype, aname];
  }

  attr_type(attr: string){
    return this._attr_type_and_name(attr)[0];
  }

  attr_name(attr: string){
    return this._attr_type_and_name(attr)[1];
  }

  reload_table(){
      this.loading = true;
      this.headers = [
        { title: 'product#', sort_field: 'id', class: 'th--normal', width: '12em' },
        { title: 'SKU', sort_field: this.dataService.SKU_id, class: 'th--normal', width: '12em' },

        { title: 'name', sort_field: 'name_' + this.primary_lang, class: 'th--small', width: '20em' },
        { title: 'tag', sort_field: 'tag_' + this.primary_lang, class: 'th--small', width: '10em' },
        { title: 'filter', sort_field: 'filter_' + this.primary_lang, class: 'th--small', width: '12em' },

        // { title: 'description', sort_field: 'description', class: 'th--normal', width: '30em' },
        { title: 'base price', sort_field: 'base_price', class: 'th--normal-right', width: '7em' },
      ];

      for( const grp of this.available_groups){
        this.headers.push({ title: grp + ' price', sort_field: 'partner_price_'+grp, class: 'th--normal-right', width: '7em' });
      }

      this.headers.push({ title: 'status', sort_field: 'status',  class: 'th--small', width: '12em' });
      this.headers.push({ title: 'stock', sort_field: 'stock',  class: 'th--small', width: '8em' });

      // if(this.mode == 'new'){
      //   this.headers.push(
      //     { title: '', class: 'th--edit', with: '3em' })
      // }
      this.loading = false;
  }

  get_keys(obj){
    if(!!obj){
      return Object.keys(obj);
    } else {
      return [];
    }

  }

  add_new_bulk(prod, attr){
    let price_list = prod[attr];
    if(!price_list){
      price_list = {};
      price_list['1'] = prod.base_price;
      prod[attr] = price_list;
    }
    price_list[this.new_from] = price_list['1'];
    this.new_from = null;
  }

  duplicate_selected_products(){
    for(const prod of this.selected_products){
      let new_prod = {...prod};
      new_prod.id = 'copy_of_' + prod.id;
      if(!!prod[this.dataService.SKU_id]) {
        new_prod[this.dataService.SKU_id] = 'copy of ' + prod[this.dataService.SKU_id];
      }
      const idx = this.products.indexOf(prod);
      this.products.splice(idx+1,0, new_prod);
      this.mark_as_changed(new_prod);
    }
    this.selected_products = [];
  }

  add_product(){
    let p: any;
    const mess = "please enter a UNIQ ID here";
    for( p of this.products ){
      if(p.id == mess){
        break;
      }
    }
    if(!p || p.id != mess) {
      let new_prod = {...this.products[0]};
      for (const a in new_prod) {
        new_prod[a] = undefined;
      }

      new_prod.status = 'AVAILABLE';
      new_prod.id = mess;
      new_prod.SKU = mess.replace('UNIQ ID', 'VALID SKU');
      this.products.unshift(new_prod);

      this.mark_as_changed(new_prod);
      this.expandedRows[new_prod.id] = 1;
    } else {
      this.expandedRows[p.id] = 1;
    }

    this.producttable.filterGlobal(mess, 'contains');
    setTimeout(()=>{
      this.producttable.filterGlobal('', 'contains');
    }, 3000);
  }

  get_products(refresh: boolean = false) {
    this.loading = true;
    this.dataService.get('product').subscribe(result => {
        this.loading = false;
        this.last_fetch = new Date();

        this.products = [];
        this.assets = [];
        for(let pr of result){
          if(pr.status != 'ASSET'){
            this.products.push(pr);
          } else {
            this.assets.push(pr);
          }
        }
        this.changed_products = {};

        let seen_filters =  {};
        for(const lng of this.dataService.known_languages){
          seen_filters[lng] = {};
        }
        // add for easy full text search ....
        for (let product of this.products) {
          // if (!!product.show_to_group && product.show_to_group.length === 1) {
          //   const grp = product.show_to_group[0];
          //   const grp_price = product['partner_price_' + grp];
          //   product.base_price = grp_price;
          // }
          if( !!product.show_to_group ){
            for( let gr of product.show_to_group ){
              if( this.available_groups.indexOf(gr) == -1){
                this.available_groups.push(gr);
              }
            }
          }
          if( this.dataService.known_languages.length == 1){
            for( const attr of this.base_editable_attributes ){
              if( attr.slice(-1) == '_' ){
                product[attr + this.primary_lang] = product[attr.slice(0,-1)];
              }
            }
          }
          product.as_text = JSON.stringify(product);
          for(const lng of this.dataService.known_languages){
            const LNG = lng.toUpperCase();
            const filter_val = product['filter_'+ LNG];
            if(!!filter_val){
              seen_filters[lng][filter_val] = true;
            }
          }
        }
        // add partner pricing
        this.editable_attributes = [...this.base_editable_attributes];
        for( const grp of this.available_groups ){
          this.editable_attributes.push('partner_price_'+grp+'$');
        }
        this.editable_attributes.push('price_from_unit_count&');
        this.filter_choices_by_lang = {};
        for(const lng of this.dataService.known_languages){
          this.filter_choices_by_lang[lng.toUpperCase()] = Object.keys(seen_filters[lng]);
          this.filter_choices_by_lang[lng.toUpperCase()].sort();
        }
        this.reload_table();
      },
      (err) => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  count_changes(){
    let cnt = 0;
    for(const pr of this.products){
      if(!!pr.changed) cnt += 1;
    }
    return cnt;
  }

  upload_changes(){
    let lst = [];
    for(const pr of this.products){

      if(!pr.price_from_unit_count){
        pr.price_from_unit_count = {};
      }
      pr.price_from_unit_count[1] = pr.base_price;

      if(!!pr.changed){
        let prc = {...pr};
        delete prc.changed;
        delete prc.as_text;
        if( this.dataService.known_languages.length == 1){
          for( const attr of this.editable_attributes ){
            if( attr.slice(-1) == '_' ){
              prc[attr.slice(0,-1)] = prc[attr + this.primary_lang];
              delete prc[attr + this.primary_lang];
            }
          }
        }
        lst.push(prc);
        pr.changed = false;
        pr.uploading = true;
      }
    };
    this.loading = true;
    this.dataService.post('product/batch', lst).subscribe(result=>{
      for(let pr of this.products){
         for(const npr in result){
          if(pr['id'] == npr['id']){
            pr = npr;
          }
        }

        if( this.dataService.known_languages.length == 1){
          for( const attr of this.editable_attributes ){
            if( attr.slice(-1) == '_' ){
              pr[attr + this.primary_lang] = pr[attr.slice(0,-1)];
            }
          }
        }
      }
      this.loading = false;
    },err =>{
      // handle error ...
    })
  }

  _handle_upload_result(prod, res) {
    // prod.img = res['secure_url'].replace('/v'+res['version'], '/t_m240');
    prod.images = [];
    prod.images.push( res['secure_url'].replace('/v' + res['version'], '') );
    // prod.img = res['secure_url']; // keep the version !
    this.mark_as_changed(prod)

    // this.dataService.put('product', { images: prod.images, id: prod.id}).subscribe(
    //   (saved) => {
    //     prod.uploading = false;
    //     prod.changed = false;
    //   });
  }

  new_img_upload(prod, event) {
    prod.uploading = true;
    this.dataService.upload_imagefile_for_product(prod, event.files[0]).subscribe(
      (res) => {
        this._handle_upload_result(prod, res);
      });
  }

  editProduct(product, new_status) {
    product.status = 'REQUEST ' + new_status;
    this.dataService.put('product', product).subscribe(new_product => {
       product.status = new_product['status'];
       product.updated_by = new_product['updated_by'];
       product.is_mine = product.updated_by == this.dataService.current_user_name;
    }, err=>{
      product.status = 'ERROR';
    });
  }

  _get_nm_from_sd(nm){
    const disc = parseFloat(nm[1]);
    const start = parseInt(nm[0]);
    let n = Math.round( start * ( 1.0 - disc ) );
    let m = start - n;
    return [n,m]
  }


  open_special_dialog(){
    this.special_definition.base_count = 3;
    this.special_definition.free_count = 1;
    this.special_definition.perc_discount = 20;
    this.special_definition.start_date = null;
    this.special_definition.end_date = null;
    this.special_definition.orig_price = this.selected_products[0].orig_price;
    const current_status = this.selected_products[0].status;
    if( current_status.startsWith('SPECIAL') ){
      if( current_status == 'SPECIAL'){
        this.special_definition.type = 'smp';
        this.special_definition.new_price = this.selected_products[0].base_price;
      } else {
        const sp_parts = current_status.split('_')
        if(sp_parts.length == 3){
          this.special_definition.type = 'n+m';
          this.special_definition.group = sp_parts[1];

          const nm = sp_parts[2].split('+');
          if( nm.length == 2 && !nm[1].startsWith('.')) {
            this.special_definition.base_count = parseInt(nm[0]);
            this.special_definition.free_count = parseInt(nm[1]);
          }
          if( nm.length == 2 && nm[1].startsWith('.')) {
            const bf = this._get_nm_from_sd(nm);
            this.special_definition.base_count = bf[0];
            this.special_definition.free_count=  bf[1];
            this.special_definition.progressive_discount = true;
          }
          if( nm.length == 3 && nm[1].startsWith('.') && nm[1].indexOf('/') > 0) {
            const nms = sp_parts[2].split('/');

            const bf1 = this._get_nm_from_sd(nms[0].split('+'));
            this.special_definition.base_count = bf1[0];
            this.special_definition.free_count=  bf1[1];

            const bf2 = this._get_nm_from_sd(nms[1].split('+'));
            this.special_definition.base_count_1 = bf2[0];
            this.special_definition.free_count_1 = bf2[1];

            this.special_definition.progressive_discount = true;
          }
        }
      }
    }
    if( !!this.selected_products[0].available_from ) {
      this.special_definition.start_date = this.selected_products[0].available_from.replace('Z', '');
    }
    if( !!this.selected_products[0].available_until ) {
      this.special_definition.end_date = this.selected_products[0].available_until.replace('Z', '');
    }

    this.display_special_dialog = true;
  }

  _get_selected_price(){
    if( !this.selected_products ) return null;
    let base_price = null;
    for(const pr of this.selected_products){
      if(!base_price){
        base_price = pr.base_price;
      } else {
        if(pr.base_price !== base_price){
          base_price = null;
        }
      }
    }
    return base_price;
  }

  _calc_new_price(orig_price, perc_discount) {
    return Math.trunc(Math.round(orig_price * (100 - perc_discount) / 100.0));
  }

  _calc_disc_ratio(base_count, free_count){
     let disc_ratio = free_count / (base_count + free_count);
     return  '.' + Math.trunc(1000 * disc_ratio);
  }

  mark_as_changed(pr){
    this.expandedRows[pr.id] = 1; // stay expanded even if the id si changed
    pr.changed  = true;
    sessionStorage.setItem('admin_products', JSON.stringify(this.products));
    // this.changed_products[pr.id] = pr;
  }

  delete_selected(){
    for(let pr of this.selected_products){
      pr.status = 'DELETED';
      this.mark_as_changed(pr);
    }
  }

  special_definition_compleet(): boolean{
    if( this.special_definition.type == 'prc'){
      return this.special_definition.perc_discount > 0;
    }

    if( this.special_definition.type == 'smp' ){
       return this.special_definition.new_price > -1;
    }

    if( this.special_definition.type == 'n+m' ){
      return !!this.special_definition.group && this.special_definition.base_count > 0  && this.special_definition.free_count > 0;
    }
    return false;
  }

  create_special(save: boolean){

    if(!save){
      this.display_special_dialog = false;
      return;
    }
    // TODO: check if all conditions are set
    for(let pr of this.selected_products){
      if( this.special_definition.type == 'rst' ) {
        if (['PNG','BR','NO','MP4', 'PDF'].indexOf(pr.SKU) == -1){
          pr.status = 'AVAILABLE';
        } else {
          pr.status = 'ASSET';
        }
        if (pr.orig_price) pr.base_price = pr.orig_price;
        if (pr.orig_from_unit_count) pr.price_from_unit_count = pr.orig_from_unit_count;
      }

      if( this.special_definition.type == 'prc' && this.special_definition.perc_discount > 0 ) {
        pr.orig_from_unit_count = pr.price_from_unit_count;
        if (pr.orig_price == undefined) pr.orig_price = pr.base_price;
        pr.base_price = this._calc_new_price(pr.orig_price, this.special_definition.perc_discount);
        // ALSO DISCOUNT THE BULK pricing !?
        for (const frm in pr.price_from_unit_count) {
          pr.price_from_unit_count[frm] = this._calc_new_price(pr.price_from_unit_count[frm], this.special_definition.perc_discount)
        }
        pr.status = 'SPECIAL';
      }
      if( this.special_definition.type == 'smp' && this.special_definition.new_price > -1 ) {
        pr.orig_from_unit_count = pr.price_from_unit_count;
        if (pr.orig_price == undefined) pr.orig_price = pr.base_price;
        pr.base_price = this.special_definition.new_price;
        // ALSO DISCOUNT THE BULK pricing if the bulk price > new price
        for (const frm in pr.price_from_unit_count) {
          pr.price_from_unit_count[frm] = Math.min(pr.price_from_unit_count[frm], this.special_definition.new_price);
        }
        pr.status = 'SPECIAL';
      }
      if( this.special_definition.type == 'n+m' && !!this.special_definition.group && this.special_definition.base_count > 0  && this.special_definition.free_count > 0) {
        if (!this.special_definition.progressive_discount) {
          pr.status = 'SPECIAL_' + this.special_definition.group + '_' + this.special_definition.base_count + '+' + this.special_definition.free_count;
          if( !!this.special_definition.free_prod_id ) {
            pr.status += '['+ this.special_definition.free_prod_id +']'
          }
        }
        else {
          const min_items = this.special_definition.base_count + this.special_definition.free_count;
          const disc_ratio = this._calc_disc_ratio(this.special_definition.base_count, this.special_definition.free_count);
          pr.status = 'SPECIAL_' + this.special_definition.group + '_' + min_items + '+' + disc_ratio;
          if(this.special_definition.base_count_1 > this.special_definition.base_count && this.special_definition.free_count_1 > this.special_definition.free_count){
            const min_items_1 = this.special_definition.base_count_1 + this.special_definition.free_count_1;
            const disc_ratio_1 = this._calc_disc_ratio(this.special_definition.base_count_1, this.special_definition.free_count_1);
            pr.status += '/' + min_items_1 + '+' +  disc_ratio_1;
          }
        }
      }

      if(!!this.special_definition.start_date && !!this.special_definition.end_date){
        pr.available_from = this.special_definition.start_date;
        pr.available_until = this.special_definition.end_date;
      } else {
        pr.available_from = null;
        pr.available_until = null;
      }
      this.mark_as_changed(pr);
    }

    // TODO: handle errors and display them
    this.display_special_dialog = false;

  }



  // createProduct() {
  //   this.show_popup = true;
  // }

  // onClose(event) {
  //   this.product = undefined;
  //   this.show_popup = false;
  // }

  onNotify(event) {
    // this.presentProduct(event.type, event.title, event.body);
  }

  // presentProduct(type: string, title: string, body: string) {
  //   this.productservice.add({severity: type, summary: title, detail: body});
  // }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/products/products.component.ts